import React from 'react';
export const TransitionHookSection = () => {
  return <section className="bg-familia-section relative py-10 md:py-16 px-4 md:px-6 overflow-hidden" data-id="element-253">
      <div className="absolute inset-0 bg-gradient-to-r from-familia-bg/60 to-familia-section opacity-60 pointer-events-none" data-id="element-254" />
      <div className="relative z-10 max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-255">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-6 md:mb-8 leading-tight" data-id="element-256">
          How much longer will the older adult{' '}
          <br className="hidden md:block" data-id="element-257" /> in your family go without a real
          care system?
        </h2>
        <div className="space-y-2 text-familia-gray text-[15px] md:text-xl max-w-2xl mx-auto" data-id="element-258">
          <p data-id="element-259">The problem isn't a lack of love or commitment.</p>
          <p data-id="element-260">
            Every caregiver reading this loves their family deeply. The problem
            is that caring for an older adult without the right system is like
            navigating without a map — exhausting, isolating and never quite
            enough.
          </p>
          <p data-id="element-261">
            Until now, there was no single resource designed so the entire
            family could participate in care with professional-level tools —
            without needing a medical degree.
          </p>
          <p className="text-white font-bold" data-id="element-262">That has changed.</p>
          <p className="text-familia-cyan font-bold" data-id="element-263">
            And it's available today.
          </p>
        </div>
      </div>
    </section>;
};